import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Snackbar, Stack } from "@mui/material";
import { useCart } from "context/CartContext";
import { useUserContext } from "context/userContext";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import CartNavigation from "../components/cart/CartNavigation";
import CartStepper from "../components/cart/CartStepper";
import StepContent from "../components/cart/StepContent";

const steps = ["Kurv", "Dine Oplysninger", "Bestil"];

function Cart({ handleCartClose }) {
  const { cartItems, emptyCart } = useCart();
  const [activeStep, setActiveStep] = useState(0);
  const { isAuth } = useUserContext();
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const totalPrice = useMemo(() => {
    const total = cartItems.reduce((acc, item) => {
      const itemPrice = item.filter.price?.Unit_Price_Discount || 0;
      return acc + itemPrice * item.quantity;
    }, 0);
    return total.toFixed(2);
  }, [cartItems]);

  const isCartEmpty = cartItems.length === 0;

  useEffect(() => {
    if (!isAuth) {
      navigate("/");
    }
  });

  const handleSubmit = () => {};
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };
  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      handleSubmit();
      emptyCart();
      setActiveStep(0);
      handleCartClose();
      return;
    }

    if (activeStep === 0 && cartItems.length === 0) {
      setOpenSnackbar(true);
      return;
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: "99%",
        maxWidth: { xs: "100%", sm: "100%", md: 600 },
        maxHeight: "92vh",
        gap: 2,
        paddingX: 1.5,
        boxSizing: "border-box",
      }}
    >
      <Stack
        sx={{ padding: "1px", marginTop: "10px" }}
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon />
      </Stack>
      <Box sx={{ overflow: "scroll" }}>
        <CartStepper steps={steps} activeStep={activeStep} />
        <StepContent activeStep={activeStep} handleNext={handleNext} />
      </Box>
      {activeStep === 0 ? (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            backgroundColor: "white",
            zIndex: 1000,
            padding: "10px",
            boxShadow: "0 -5px 10px -10px black",
            boxSizing: "border-box",
            maxHeight: "60px",
          }}
        >
          <CartNavigation
            activeStep={activeStep}
            steps={steps}
            handleBack={handleBack}
            handleNext={handleNext}
            showNextButton={activeStep !== 1 || cartItems.length > 0}
            totalPrice={totalPrice}
            isCartEmpty={isCartEmpty}
          />
        </Box>
      ) : (
        <CartNavigation
          activeStep={activeStep}
          steps={steps}
          handleBack={handleBack}
          handleNext={handleNext}
          showNextButton={activeStep !== 1 || cartItems.length > 0}
        />
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message="Din indkøbskurv er tom."
      />
    </Box>
  );
}

export default Cart;
